<div class="Patient">
  @if(Patient != null)
  {
    <div class="row mt-1 mb-1">
      <div class="col">
       <div class="row pb-3" style="border-bottom: 1px solid #efefef;">
         <div class="col">
           <div class="row">
             <div class="col-auto">
               <div class="text-bg-secondary border-secondary d-inline-block PictureInfo" >
                 <i class="fa-solid fa-user"></i>
               </div>
             </div>
             <div class="col">
               <h3>{{ Patient.anrede }} {{ Patient.nachname }}, {{ Patient.vorname }} <i style="font-weight: lighter;font-style: normal; font-size: large">({{ Patient.versicherungsnummer }} {{ Patient.kasse.name }})</i></h3>
               <span class="ContactInfo">
               <strong>Geburtsdatum: <i>{{ Patient.geburtstag | date: 'dd.MM.yyyy'}} <i class="fa-solid fa-cake-candles" style="color:orange"></i></i></strong>
               <strong>Telefon: <i><PhoneCall [number]="Patient.phone" ></PhoneCall></i></strong>
               <strong>Email: <i>{{ Patient.email }}</i><i class="fa-solid fa-envelope"></i></strong>
            </span>
               <span class="ContactInfo">
              <strong>Adresse: <i> {{ Patient.adressen[0]?.strasse }} {{ Patient.adressen[0]?.hausnummer }}, {{ Patient.adressen[0]?.plz }} {{ Patient.adressen[0]?.ort }}</i> </strong>
            </span>
             </div>
           </div>
         </div>
         <div class="col-4" style="max-width: 300px;">
           <div class="d-flex flex-column">
             <strong class="ContactInfo">Versicherungsart: <i>{{ Patient.gesetzlichVersichert | gkv}}</i></strong>
             <strong class="ContactInfo">Beihilfeberechtigt: <i>{{ Patient.beihilfe | yesNo}}</i></strong>
             <strong class="ContactInfo">Pflegegrad: <i>{{ Patient.pflegegrad  }}</i></strong>
           </div>
         </div>
       </div>
        <div class="row">
          <div class="col p-4 pb-1" style="overflow: hidden;">
            <stepper [steps]="StatusList" [activeIndex]="OrderStep ?? 0.5" ></stepper>
          </div>
        </div>
      </div>
      <div class="col-auto">
        <div class="d-flex flex-column buttonCol" style="height: 100%;width: 42px;margin-left: 1.2rem;">
          <div>
            <div class="btn btn-primary mb-1" (click)="openNotfallplan()" title="Notfallplan"><i class="bi bi-journal-text"></i></div>
          </div>
          <div>
            <div class="btn btn-primary mb-1" (click)="openKontackt()" title="Kontakte"><i class="bi bi-people-fill"></i></div>
          </div>
          <div>
            <div class="btn btn-primary" (click)="openUser()" title="Patienten Infos bearbeiten"><i class="bi bi-person-vcard"></i></div>
          </div>
        </div>
      </div>
    </div>
  }
</div>
